import { API_BASE_URL } from "../config/api";

const REFRESH_ENDPOINT = `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`;

function logoutAndRedirect() {
  ["access", "authCredentials", "refresh", "role", "email"].forEach((key) =>
    localStorage.removeItem(key),
  );
  window.location.href = "/signin";
}

export async function authFetch(url, options = {}) {
  const request = () =>
    fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
        Authorization: `Bearer ${localStorage.getItem("access")}`,
      },
    });

  let response = await request();
  if (response.status !== 401) return response;

  const refreshResponse = await fetch(REFRESH_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh: localStorage.getItem("refresh") }),
  });
  if (!refreshResponse.ok) {
    logoutAndRedirect();
    return null;
  }

  const refreshData = await refreshResponse.json();
  localStorage.setItem("access", refreshData.access);
  return request();
}

export async function responseError(response, fallback) {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    return fallback;
  }
  const first = Object.values(data || {}).flat().find(Boolean);
  return typeof first === "string" ? first : fallback;
}
